import macro from '../../macros.js';
import vtkCompositeCameraManipulator from './CompositeCameraManipulator.js';
import vtkCompositeMouseManipulator from './CompositeMouseManipulator.js';
import vtkMouseCameraTrackballRotateManipulator from './MouseCameraTrackballRotateManipulator.js';
import vtkMouseCameraTrackballRollManipulator from './MouseCameraTrackballRollManipulator.js';

function max(x, y) {
  return x < y ? y : x;
}

function sqr(x) {
  return x * x;
} // ----------------------------------------------------------------------------
// vtkMouseCameraTrackballMultiRotateManipulator methods
// ----------------------------------------------------------------------------


function vtkMouseCameraTrackballMultiRotateManipulator(publicAPI, model) {
  // Set our className
  model.classHierarchy.push('vtkMouseCameraTrackballMultiRotateManipulator');
  var rotateManipulator = vtkMouseCameraTrackballRotateManipulator.newInstance();
  var rollManipulator = vtkMouseCameraTrackballRollManipulator.newInstance();
  var currentManipulator = null;

  publicAPI.onButtonDown = function (interactor, renderer, position) {
    var viewSize = interactor.getView().getViewportSize(renderer);
    var viewCenter = [0.5 * viewSize[0], 0.5 * viewSize[1]];
    var rotateRadius = 0.9 * max(viewCenter[0], viewCenter[1]);
    var dist2 = sqr(viewCenter[0] - position.x) + sqr(viewCenter[1] - position.y);

    if (rotateRadius * rotateRadius > dist2) {
      currentManipulator = rotateManipulator;
    } else {
      currentManipulator = rollManipulator;
    }

    currentManipulator.setButton(publicAPI.getButton());
    currentManipulator.setShift(publicAPI.getShift());
    currentManipulator.setControl(publicAPI.getControl());
    currentManipulator.setCenter(publicAPI.getCenter());
    currentManipulator.onButtonDown(interactor, position);
  };

  publicAPI.onButtonUp = function (interactor) {
    if (currentManipulator) {
      currentManipulator.onButtonUp(interactor);
    }
  };

  publicAPI.onMouseMove = function (interactor, renderer, position) {
    if (currentManipulator) {
      currentManipulator.onMouseMove(interactor, renderer, position);
    }
  };
} // ----------------------------------------------------------------------------
// Object factory
// ----------------------------------------------------------------------------


var DEFAULT_VALUES = {}; // ----------------------------------------------------------------------------

function extend(publicAPI, model) {
  var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.assign(model, DEFAULT_VALUES, initialValues); // Inheritance

  macro.obj(publicAPI, model);
  vtkCompositeMouseManipulator.extend(publicAPI, model, initialValues);
  vtkCompositeCameraManipulator.extend(publicAPI, model, initialValues); // Object specific methods

  vtkMouseCameraTrackballMultiRotateManipulator(publicAPI, model);
} // ----------------------------------------------------------------------------

var newInstance = macro.newInstance(extend, 'vtkMouseCameraTrackballMultiRotateManipulator'); // ----------------------------------------------------------------------------

var vtkMouseCameraTrackballMultiRotateManipulator$1 = {
  newInstance: newInstance,
  extend: extend
};

export { vtkMouseCameraTrackballMultiRotateManipulator$1 as default, extend, newInstance };
